/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateFormStatusRequest
 */
export interface UpdateFormStatusRequest {
    /**
     * 
     */
    status?: UpdateFormStatusRequestStatusEnum;
}


/**
 * @export
 */
export const UpdateFormStatusRequestStatusEnum = {
    Pending: 'PENDING',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Overdue: 'OVERDUE',
    Cancelled: 'CANCELLED',
} as const;
export type UpdateFormStatusRequestStatusEnum = typeof UpdateFormStatusRequestStatusEnum[keyof typeof UpdateFormStatusRequestStatusEnum];


/**
 * Check if a given object implements the UpdateFormStatusRequest interface.
 */
export function instanceOfUpdateFormStatusRequest(value: object): value is UpdateFormStatusRequest {
    return true;
}

export function UpdateFormStatusRequestFromJSON(json: any): UpdateFormStatusRequest {
    return UpdateFormStatusRequestFromJSONTyped(json, false);
}

export function UpdateFormStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFormStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function UpdateFormStatusRequestToJSON(json: any): UpdateFormStatusRequest {
    return UpdateFormStatusRequestToJSONTyped(json, false);
}

export function UpdateFormStatusRequestToJSONTyped(value?: UpdateFormStatusRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
    };
}

